"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Construct set of row-cols classes from a breakpoint mapping.
 */
var getColumnClass = function (defn) {
    var classes;
    if (typeof defn === "number") {
        classes = ["row", "row-cols-" + defn];
    }
    else {
        classes = ["row"];
        ["xs", "sm", "md", "lg", "xl"].forEach(function (bp) {
            if (defn[bp] && classes.length > 1) {
                classes.push("row-cols-" + bp + "-" + defn[bp]);
            }
            else if (defn[bp]) {
                classes.push("row-cols-" + defn[bp]);
            }
        });
    }
    return classes.join(" ");
};
exports.default = {
    getColumnClass: getColumnClass,
};
